/* REACT */
import React, { useEffect, useState } from 'react'

/* 3RD PARTIES */
import { connect } from 'react-redux'
import cookie from 'react-cookies'
import { useMediaQuery } from 'react-responsive'
import queryString from 'query-string'

/* @ts-ignore */

/* COMPONENTS */
import FullPage from './FullPage/FullPage'
import Popover from './Popover/Popover'

/* STORE */
import {
  fetchOrganizationDetails,
  fetchDefaultChat,
  joinSocketRoom,
  fetchChat,
} from '../../store/maya/actions'
import {
  setGeneralConfig,
  autoOpenPopoverChat,
  setIsPopoverChatOpen,
  setOpenPopoverOnClickthrough,
} from '../../store/general/actions'

/* STYLES */

/* UTILS/CONSTANTS */
import { size } from '../../utils/constants'
import {
  getMayaCookieNameChatSlug,
  getMayaCookieNameChatToken,
  saveChatTokenAndSlugToCookie,
} from '../../utils/helpers'

/* ASSETS */

function Chat({
  organizationKey,
  organizationSlug,
  language,
  widgetMode,
  chatMode,
  organizationDetails,
  fetchDefaultChat,
  stateOrganizationSlug,
  stateOrganizationKey,
  stateLanguage,
  stateWidgetMode,
  stateChatMode,
  setGeneralConfig,
  slug,
  token,
  fetchChat,
  autoOpenPopoverChat,
  setIsPopoverChatOpen,
  setOpenPopoverOnClickthrough,
  introType,
}) {
  const [detailsFetched, setDetailsFetched] = useState(false)
  const [defaultChatFetched, setDefaultChatFetched] = useState(false)
  const [isCookiesSet, setIsCookiesSet] = useState(false)
  const [organizationDetailsChecked, setOrganizationDetailsChecked] =
    useState(false)

  const [isConfigSet, setIsConfigSet] = useState(false)

  const isLessThanLaptop = useMediaQuery({
    query: `(max-width: ${size.laptop})`,
  })

  // CALCULATE THE HEIGHT OCCUPIED BY FIXED ELEMENTS ABOVE THE WIDGET
  const getFixedElementsHeight = () => {
    let totalFixedHeight = 0
    const fixedElements = []

    // Get all elements and check their computed styles
    const allElements = document.querySelectorAll('*')

    allElements.forEach(element => {
      const computedStyle = window.getComputedStyle(element)
      const rect = element.getBoundingClientRect()

      // Check if element is fixed positioned
      if (computedStyle.position === 'fixed') {
        // Only count elements that are positioned at the top and visible
        if (
          rect.top >= 0 &&
          rect.top < window.innerHeight &&
          computedStyle.display !== 'none' &&
          computedStyle.visibility !== 'hidden' &&
          rect.height > 0
        ) {
          totalFixedHeight += rect.height
          fixedElements.push({
            element,
            height: rect.height,
            top: rect.top,
            tagName: element.tagName,
            className: element.className,
            id: element.id,
          })
        }
      }
    })

    // Sort fixed elements by their top position to get the total height from top
    fixedElements.sort((a, b) => a.top - b.top)

    // Calculate the total height from the top of the viewport
    let maxBottom = 0
    fixedElements.forEach(fixedEl => {
      const bottom = fixedEl.top + fixedEl.height
      if (bottom > maxBottom) {
        maxBottom = bottom
      }
    })

    // Return the maximum bottom position as the height to subtract
    return maxBottom
  }

  // CALCULATE THE DISTANCE FROM TOP FOR OUR FULL SCREEN APP
  const getDistanceFromTop = element => {
    let distance = 0
    while (element) {
      distance += element.offsetTop
      element = element.offsetParent
    }
    return distance
  }

  const setReactAppHeight = () => {
    // Get the total height of the screen
    const screenHeight = window.innerHeight

    // Get the container element of your React app
    const reactAppContainer = document.querySelector(
      '#maya-b2b-full-page[data-widget-mode="full-page"], #maya-b2b-full-page[data-widget-mode="popover"]'
    )

    if (reactAppContainer) {
      // Get the actual position of the widget container
      const containerRect = reactAppContainer.getBoundingClientRect()

      // Calculate the height of elements before your React app (normal flow)
      const heightOfElementsBeforeApp = getDistanceFromTop(reactAppContainer)

      // Calculate the height of fixed elements
      const fixedElementsHeight = getFixedElementsHeight()

      // Use the actual top position of the container as the most accurate measurement
      const containerTopPosition = containerRect.top

      // Calculate the height to set for your React app
      // Use the container's actual top position, or fallback to calculated values
      const totalHeightToSubtract =
        containerTopPosition > 0
          ? containerTopPosition
          : Math.max(heightOfElementsBeforeApp, fixedElementsHeight)

      const reactAppHeight = screenHeight - totalHeightToSubtract

      // Set the height of your React app
      reactAppContainer.style.height = `${reactAppHeight}px`
    }
  }

  useEffect(() => {
    // SET HEIGHT OF FULL PAGE APP

    // ONLY SET HEIGHTS FOR FULL SCREEN VIEW
    if (widgetMode === 'full-page' || !widgetMode) {
      // Call the function when the page is loaded
      window.addEventListener('load', setReactAppHeight)
      // Add event listener for screen resize
      window.addEventListener('resize', setReactAppHeight)

      // ADD MUTATION OBVERSVER TO LISTEN TO DOM CHANGES AND SEE IF HEIGHT NEEDS TO BE RESET
      // Create a MutationObserver instance
      const mutationObserver = new MutationObserver(setReactAppHeight)

      // Specify the target node and options for the observer
      const targetNode = document.querySelector(
        '#maya-b2b-full-page[data-widget-mode="full-page"], #maya-b2b-full-page[data-widget-mode="popover"]'
      )
      const config = { childList: true, subtree: true }

      if (targetNode) {
        // Start observing the target node for changes
        mutationObserver.observe(targetNode, config)
      }

      // Return a cleanup function to remove the event listeners
      return () => {
        window.removeEventListener('load', setReactAppHeight)
        window.removeEventListener('resize', setReactAppHeight)
        mutationObserver.disconnect()
      }
    }
  }, [])

  const setOpenPopoverStatusOnClickthrough = organizationDetails => {
    // Find the first element with a non-null openPopupOnClicktrhoughDesktop value
    const foundAutoPopupElementDesktop = organizationDetails?.configs?.find(
      element => element.openPopupOnClicktrhoughDesktop !== null
    )

    // Get the openPopupOnClicktrhoughDesktop value if found
    const openPopupOnClicktrhoughDesktopValue = foundAutoPopupElementDesktop
      ? foundAutoPopupElementDesktop.openPopupOnClicktrhoughDesktop
      : null

    // Find the first element with a non-null openPopupOnClickthroughMobile value
    const openPopupOnClickthroughMobile = organizationDetails?.configs?.find(
      element => element.autoOpenPopupTimeMobile !== null
    )

    // Get the openPopupOnClicktrhoughMobile value if found
    const openPopupOnClickthroughMobileValue = openPopupOnClickthroughMobile
      ? openPopupOnClickthroughMobile.openPopupOnClicktrhoughMobile
      : null

    const autoOpenPopupValueCurrent = isLessThanLaptop
      ? openPopupOnClickthroughMobileValue
      : openPopupOnClicktrhoughDesktopValue
    if (autoOpenPopupValueCurrent) {
      setOpenPopoverOnClickthrough(autoOpenPopupValueCurrent)
    }
  }

  useEffect(() => {
    if (!organizationDetailsChecked && organizationDetails) {
      setOpenPopoverStatusOnClickthrough(organizationDetails)
      setOrganizationDetailsChecked(true) // SET TO TRUE

      // OPEN POPOVER CHAT IF ITS ALREADY SET TO OPEN IN COOKIE
      if (
        cookie.load(
          `maya_is_popover_chat_open_${process.env.REACT_APP_API_ENV}`
        )
      ) {
        setIsPopoverChatOpen(true)
      }

      // Find the first element with a non-null autoOpenPopupTimeDesktop value
      const foundAutoPopupElementDesktop = organizationDetails?.configs?.find(
        element => element.autoOpenPopupTimeDesktop !== null
      )

      // Get the autoOpenPopupTimeDesktop value if found
      const autoOpenPopupTimeDesktopValue = foundAutoPopupElementDesktop
        ? foundAutoPopupElementDesktop.autoOpenPopupTimeDesktop
        : null

      // Find the first element with a non-null foundAutoPopupElementMobile value
      const foundAutoPopupElementMobile = organizationDetails?.configs?.find(
        element => element.autoOpenPopupTimeMobile !== null
      )

      // Get the autoOpenPopupTimeDesktop value if found
      const autoOpenPopupTimeMobileValue = foundAutoPopupElementMobile
        ? foundAutoPopupElementMobile.autoOpenPopupTimeDesktop
        : null

      const autoOpenPopupValueCurrent = isLessThanLaptop
        ? autoOpenPopupTimeMobileValue
        : autoOpenPopupTimeDesktopValue

      // WHEN SETTING CONFIG ALSO CHECK WHETHER TO AUTO OPEN POPUP OR NOT
      // USE COOKIES, IF CHAT ALREADY AUTO OPENED THEN DONT AUTO OPEN IT AGAIN FOR SAME USER SESSION
      if (
        !cookie.load(
          `maya_chat_auto_open_popover_${process.env.REACT_APP_API_ENV}_${
            isLessThanLaptop ? 'mobile' : 'desktop'
          }`
        ) &&
        autoOpenPopupValueCurrent !== null
      ) {
        // DEFAULT OPEN POPOVER CHAT AFTER 30 SECONDS
        setTimeout(() => {
          // IF USER HAS ALREADY MANUALLY OPENED OR CLOSED THE CHAT, ACTION WONT OPEN IT AGAIN
          autoOpenPopoverChat()
          cookie.save(
            `maya_chat_auto_open_popover_${process.env.REACT_APP_API_ENV}_${
              isLessThanLaptop ? 'mobile' : 'desktop'
            }`,
            'true',
            { path: '/', maxAge: 86400, domain: window.location.hostname }
          )
        }, autoOpenPopupValueCurrent * 1000)
      }
    }
  }, [organizationDetails])

  useEffect(() => {
    if (!isConfigSet && organizationKey && organizationSlug && language) {
      setIsConfigSet(true) // JUST SET SOCKET ONE TIME

      const { query } = queryString.parseUrl(window.location.search)

      // SAVE CREDENTIALS IN STORE
      setGeneralConfig({
        organizationKey,
        organizationSlug,
        language: language || 'en',
        widgetMode: widgetMode,
        chatMode: chatMode, // b2c IS OUR DEFAULT EXISTING CHAT MODE
        introType: introType || query?.intro_type || 'default', // default intro type i.e. default messages
      })
    }
  }, [])

  useEffect(() => {
    // HOOK HANDLING FOR FETCHING ORGANIZATION DETAILS
    if (
      stateOrganizationSlug &&
      stateOrganizationKey &&
      stateLanguage &&
      stateWidgetMode &&
      stateChatMode &&
      !detailsFetched
    ) {
      setDetailsFetched(true)
      // FETCH ORGANIZATION DETAILS
      fetchOrganizationDetails()
    }

    // HOOK HANDLING FOR FETCHING DEFAULT CHAT SLUG AND TOKEN BASED ON ORGANIZATION DETAILS IF REQUIRED
    if (
      stateOrganizationSlug &&
      stateOrganizationKey &&
      stateLanguage &&
      stateChatMode &&
      !defaultChatFetched
    ) {
      let cookieNameChatSlug = getMayaCookieNameChatSlug({
        chatMode: stateChatMode,
        language: stateLanguage,
        organizationSlug: stateOrganizationSlug,
      })
      let cookieNameChatToken = getMayaCookieNameChatToken({
        chatMode: stateChatMode,
        language: stateLanguage,
        organizationSlug: stateOrganizationSlug,
      })

      setDefaultChatFetched(true)

      const { query } = queryString.parseUrl(window.location.search)

      if (query?.slug && (query?.token || query['amp;token'])) {
        let querySlug = query?.slug
        let queryToken = query?.token || query['amp;token']

        fetchChat(querySlug, queryToken)
      } else if (
        !cookie.load(cookieNameChatSlug) ||
        !cookie.load(cookieNameChatToken)
      ) {
        // FETCH DEFAULT CHAT
        fetchDefaultChat()
      } else {
        // FETCH EXISTING CHAT FROM BACKEND
        fetchChat(
          cookie.load(cookieNameChatSlug),
          cookie.load(cookieNameChatToken)
        )
      }
    }
  }, [
    stateOrganizationSlug,
    stateOrganizationKey,
    stateLanguage,
    stateWidgetMode,
  ])

  useEffect(() => {
    // HOOK FOR SETTING COOKIES
    if (
      stateOrganizationSlug &&
      stateChatMode &&
      stateLanguage &&
      slug &&
      token &&
      !isCookiesSet
    ) {
      let cookieNameChatSlug = getMayaCookieNameChatSlug({
        chatMode: stateChatMode,
        language: stateLanguage,
        organizationSlug: stateOrganizationSlug,
      })
      let cookieNameChatToken = getMayaCookieNameChatToken({
        chatMode: stateChatMode,
        language: stateLanguage,
        organizationSlug: stateOrganizationSlug,
      })

      // SET IS COOKIES SET TO TRUE
      setIsCookiesSet(true)

      saveChatTokenAndSlugToCookie({
        slug,
        token,
        cookieNameChatSlug,
        cookieNameChatToken,
      })

      if (process.env.REACT_APP_API_ENV !== 'production') {
        // ONLY FOR NON PRODUCTION ENVIRONMENTS
        // ADD SLUG AND TOKEN TO URL IF NOT PRESENT
        // HELPS TO COPY THE URL AND SHARE FOR EASY DEBUGGING

        const { query } = queryString.parseUrl(window.location.search)

        if (!query?.slug || (!query?.token && !query['amp;token'])) {
          // Update the URL with the new search query (without reloading the page)
          const url = new URL(window.location)
          url.searchParams.set('slug', slug)
          url.searchParams.set('token', token)
          window.history.pushState({ path: url.href }, '', url.href)
        }
      }

      // JOIN SOCKET ROOM
      joinSocketRoom(slug)
    }
  }, [slug, token, stateLanguage, stateChatMode, stateOrganizationSlug])

  return (
    <>
      {slug && token && stateWidgetMode ? (
        stateWidgetMode === 'full-page' ? (
          <FullPage language={language} />
        ) : (
          <Popover language={language} />
        )
      ) : null}
    </>
  )
}

const mapStateToProps = state => ({
  organizationDetails: state.maya.organizationDetails,
  stateOrganizationSlug: state.general.organizationSlug,
  stateOrganizationKey: state.general.organizationKey,
  stateLanguage: state.general.language,
  stateWidgetMode: state.general.widgetMode,
  stateChatMode: state.general.chatMode,
  slug: state.maya.slug,
  token: state.maya.token,
})

const mapDispatchToProps = dispatch => ({
  setGeneralConfig: config => dispatch(setGeneralConfig(config)),
  fetchDefaultChat: () => dispatch(fetchDefaultChat()),
  fetchChat: (slug, token) => dispatch(fetchChat(slug, token)),
  autoOpenPopoverChat: () => dispatch(autoOpenPopoverChat()),
  setIsPopoverChatOpen: value => dispatch(setIsPopoverChatOpen(value)),
  setOpenPopoverOnClickthrough: value =>
    dispatch(setOpenPopoverOnClickthrough(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Chat)
